import { render, staticRenderFns } from "./Section.component.vue?vue&type=template&id=7f061d84"
import script from "./Section.component.vue?vue&type=script&lang=js"
export * from "./Section.component.vue?vue&type=script&lang=js"
import style0 from "./Section.component.vue?vue&type=style&index=0&id=7f061d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports